var map = {
	"./de": 80319,
	"./de.js": 80319,
	"./de.json": 80828,
	"./en": 14819,
	"./en.js": 14819,
	"./en.json": 79124,
	"./xing/de.json": 26099,
	"./xing/en.json": 5100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53902;